import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const AssignedUserCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Assigned user",
    cell: (row) => {
      return row.assignedUser?.name || "";
    },
  };
